import { message } from '@/utils/wuji-message';
import wujiFetch from '@utils/wujiFetch';
import { requestCgi } from '@tencent/wuji-source';
import { BASE_XY_API_PATH } from '@config/constant';
import { computed, onMounted, ref } from '@vue/composition-api';
import { cloneDeep } from 'lodash';
export function useDepartmentTree(groupId) {
    const departmentList = ref([]);
    const fetchDepartments = async () => {
        try {
            let data;
            if (window.GLOBAL_INFO?.organizationAIEnable) {
                const result = await wujiFetch(`${BASE_XY_API_PATH}/group/${groupId}/department`, {
                    query: { page: 1, size: 15000 },
                });
                data = result ?? [];
            }
            else {
                // 兼容旧版 server（无 /group/:groupId/department 路由），走组织项目 CGI
                const { body } = await requestCgi('departments', 'list', {
                    query: { page: 1, size: 15000 },
                }, {
                    projectId: `${groupId}_organization`,
                    envId: 'prod',
                    pageId: 'user',
                });
                if (body.code !== 0)
                    throw new Error(body.message || '获取部门列表失败');
                data = body.data ?? [];
            }
            departmentList.value = data;
        }
        catch (error) {
            console.error(error);
            message.error('获取部门列表失败，请确认是否初始化组织架构');
        }
    };
    const departmentTree = computed(() => {
        const departments = cloneDeep(departmentList.value);
        // 获取部门id-map
        const departmentsMap = {};
        departments.forEach((department) => {
            departmentsMap[department.id] = department;
        });
        departments.forEach((department) => {
            if (department.parentId && departmentsMap?.[department.parentId]) {
                if (departmentsMap[department.parentId].children) {
                    departmentsMap[department.parentId].children.push(department);
                }
                else {
                    departmentsMap[department.parentId].children = [department];
                }
            }
        });
        // 没有 parentId 表示为根部门
        return departments.filter(department => !department.parentId);
    });
    const departmentTreeSelectData = computed(() => {
        const oTree = departmentTree.value;
        const walk = (node) => {
            const { id, name, children } = node;
            const option = {
                value: id,
                label: name,
            };
            if (children?.length) {
                option.children = children.map(walk);
            }
            return option;
        };
        const optionTree = oTree.map(walk);
        return optionTree;
    });
    onMounted(() => {
        fetchDepartments();
    });
    return {
        departmentList,
        departmentTree,
        departmentTreeSelectData,
    };
}
